module.exports = __webpack_public_path__ + "img/00005.3d6336d8.webp";